import React from "react";
import { useTranslation } from "react-i18next";

import type { FreePlanCardProps } from "./plans.types";

import styles from "./planCard.module.css";

const FREE_FEATURE_KEYS = ["publicTrees", "editors", "core"] as const;

const FreePlanCard = ({ isCurrent }: FreePlanCardProps) => {
	const { t } = useTranslation("plansPage");

	return (
		<section className={styles.card}>
			{isCurrent && <span className={styles.currentBadge}>{t("currentPlan")}</span>}

			<h2 className={styles.planName}>{t("free.name")}</h2>

			<div className={styles.price}>
				<span className={styles.priceAmount}>{t("free.price")}</span>
			</div>
			<p className={styles.billedNote}>{t("free.priceNote")}</p>

			<ul className={styles.featureList}>
				{FREE_FEATURE_KEYS.map((key: string) => (
					<li key={key} className={styles.featureItem}>
						<span aria-hidden="true" className={styles.featureMark}>
							✓
						</span>
						<span>{t(`free.features.${key}`)}</span>
					</li>
				))}
			</ul>

			{isCurrent && (
				<button className={styles.currentButton} type="button" disabled>
					{t("free.cta")}
				</button>
			)}
		</section>
	);
};

export default FreePlanCard;
